import { Tooltip ,Box } from "@mui/material";
import OrderStatusChip from "./OrderStatusChip";


export const columns = [
  {
    field: "id",
    headerName: "Id",
    flex: 1,
    minWidth: 70,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1,
    minWidth: 100,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    minWidth: 100,
    sortable: true,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "openingBal",
    headerName: "Open Bal",
    flex: 1,
    minWidth: 100,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "closingBal",
    headerName: "Close Bal",
    flex: 1,
    minWidth: 100,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "remark",
    headerName: "Remark",
    flex: 1,
    minWidth: 150,
    sortable: true,
    type: "string",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Tooltip
        title={params.value || "-"}
        arrow
        slotProps={{
          tooltip: {
            sx: {
              fontSize: "10px",
              fontFamily: "Be Vietnam Pro",
              maxWidth: "400px",
            },
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
        >
          {params.value || "-"}
        </Box>
      </Tooltip>
    ),
  },
  {
    field: "Status",
    headerName: "Status",
    flex: 1,
    minWidth: 120,
    sortable: true,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => <OrderStatusChip value={params?.value} />,
  },
];
